var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"delete-overlay flex items-center justify-center text-center"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.item.name))]),_c('p',[_vm._v("Is Being deleted")]),_c('i',{staticClass:"far fa-spinner-third fa-spin"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }